import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { createResource } from "@/model/Resource";
import { inject, onMounted, ref } from "vue";
import { ResourceServiceSymbol } from "@/InjectionSymbols";
import { validationRules } from "@/ValidationRules";
import { ResourceType } from "@/model/enum/ResourceType";
import { useMessageStore } from "@/stores/MessageStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditResourceView',
    props: {
        id: { type: Number, required: false },
        resourceType: { type: String, required: false }
    },
    setup(__props) {
        const resourceService = inject(ResourceServiceSymbol);
        const messageStore = useMessageStore();
        const props = __props;
        const form = ref(null);
        const editResource = ref(createResource(ResourceType.RESOURCE));
        let saveInFlight = ref(false);
        onMounted(() => {
            if (props.id) {
                resourceService?.loadResource(props.id, resourceLoaded);
            }
            else if (props.resourceType) {
                editResource.value.resourceType = props.resourceType;
            }
        });
        function resourceLoaded(resource) {
            editResource.value = resource;
        }
        function save() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    saveInFlight.value = true;
                    resourceService.createOrUpdateResource(editResource.value).then(response => {
                        editResource.value = response.data;
                        messageStore.addMessage("Erfolgreich gespeichert");
                        saveInFlight.value = false;
                    }).catch(() => {
                        saveInFlight.value = false;
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_form, {
                    ref_key: "form",
                    ref: form
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_container, {
                            fluid: "",
                            class: "d-flex flex-wrap justify-start"
                        }, {
                            default: _withCtx(() => [
                                (!editResource.value.id)
                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                        key: 0,
                                        class: "ma-0 d-flex justify-start text-h4 v-col-12"
                                    }, {
                                        default: _withCtx(() => [
                                            (editResource.value.resourceType == _unref(ResourceType).RESOURCE)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode("Neue Resource anlegen")
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (editResource.value.resourceType == _unref(ResourceType).ATTRIBUTE)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode("Neue Eigenschaft anlegen")
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (editResource.value.id)
                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                        key: 1,
                                        class: "ma-0 d-flex justify-start text-h4 v-col-12"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(editResource.value.name), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_container, {
                                    class: "d-flex flex-wrap v-col-6",
                                    fluid: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_container, { class: "text-h6 d-flex justify-start" }, {
                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                _createTextVNode("Basis Daten")
                                            ])),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_text_field, {
                                            class: "v-col-2 compact",
                                            modelValue: editResource.value.id,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editResource.value.id) = $event)),
                                            label: "ID",
                                            disabled: "",
                                            variant: "outlined",
                                            "data-cy": "id"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                            class: "v-col-10 compact",
                                            modelValue: editResource.value.name,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editResource.value.name) = $event)),
                                            rules: [_unref(validationRules).required],
                                            label: "Name",
                                            variant: "outlined",
                                            "data-cy": "name"
                                        }, null, 8, ["modelValue", "rules"]),
                                        (editResource.value.resourceType == _unref(ResourceType).RESOURCE)
                                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                key: 0,
                                                class: "v-col-10 compact",
                                                modelValue: editResource.value.totalQuantity,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editResource.value.totalQuantity) = $event)),
                                                rules: [_unref(validationRules).required, _unref(validationRules).nonNegativeInteger],
                                                label: "Anzahl gesamt",
                                                variant: "outlined",
                                                "data-cy": "quantity"
                                            }, null, 8, ["modelValue", "rules"]))
                                            : _createCommentVNode("", true),
                                        (editResource.value.resourceType == _unref(ResourceType).RESOURCE)
                                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                key: 1,
                                                class: "v-col-10 compact",
                                                modelValue: editResource.value.capacity,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editResource.value.capacity) = $event)),
                                                rules: [_unref(validationRules).required, _unref(validationRules).nonNegativeInteger],
                                                label: "Kapazität",
                                                variant: "outlined",
                                                "data-cy": "capacity"
                                            }, null, 8, ["modelValue", "rules"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 512),
                _createVNode(_component_v_btn, {
                    onClick: save,
                    "data-cy": "save"
                }, {
                    default: _withCtx(() => [
                        (!_unref(saveInFlight))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Speichern"))
                            : _createCommentVNode("", true),
                        (_unref(saveInFlight))
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 1,
                                indeterminate: true
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
